export async function polyfill(): Promise<void> {
	const { shouldPolyfill: shouldPolyfillDurationFormat } =
		await import("@formatjs/intl-durationformat/should-polyfill.js");
	const { shouldPolyfill: shouldPolyfillGetCanonicalLocales } =
		await import("@formatjs/intl-getcanonicallocales/should-polyfill.js");

	if (shouldPolyfillDurationFormat()) {
		await import("@formatjs/intl-durationformat/polyfill.js");
	}
	if (shouldPolyfillGetCanonicalLocales()) {
		await import("@formatjs/intl-getcanonicallocales/polyfill.js");
	}

	if (!("Temporal" in window)) {
		await import("temporal-polyfill/global");
	}
}
